import { useEffect, useRef } from 'react';
import { useAlertView } from '~/app';
import { sendSuccessAlert } from '~/features/utils';
import { RESPONSE_DECLINED_ALERT_TEXT } from './responseCloseConfirmations';

/**
 * [MCV-1850] Toasts "Response declined" once per acknowledged decline. The receipt
 * is the machine's record of a write the server confirmed, so an unconfirmed
 * outcome that a later review turns up never claims a decline.
 *
 * The actor outlives this page, so a receipt already present at mount is not ours.
 */
export const useResponseDeclinedToast = (
  receipt: { action: { kind: string }; revision: number } | null
) => {
  const alertView = useAlertView();
  const alertViewRef = useRef(alertView);
  alertViewRef.current = alertView;
  const seenRevision = useRef(receipt?.revision ?? null);
  useEffect(() => {
    if (!receipt || receipt.revision === seenRevision.current) return;
    seenRevision.current = receipt.revision;
    if (receipt.action.kind === 'reject')
      alertViewRef.current.send(
        sendSuccessAlert({
          text: RESPONSE_DECLINED_ALERT_TEXT,
          subText: 'The other party has been notified.',
        })
      );
  }, [receipt]);
};
